export const getInvitation = (state, props) => {
	const invitationId = props.invitationId;
	return state.invitation.invitations[invitationId] && state.invitation.invitations[invitationId].data;
}


/** WEBPACK FOOTER **
 ** ./src/store/invitationStore.js
 **/